import React, { useMemo, useState } from 'react';
import './style.scss';
import clsx from 'clsx';
import CardsCompareTableHeader from './shared/header';
import CardsCompareTableFeatureLine from './shared/featureLine';
import { cardsCompareFeatureTypes } from '../../../utils';
import Sticky from 'react-sticky-el';
import Button from '../../../../Shared/components/controls/Button';

const CardsCompareTable = ({ cards: externalCards }) => {
  const [cards, setCards] = useState(externalCards);

  const features = useMemo(() => {
    const transformed = cards.map((card) => card?.fields?.fullFeaturesList || []);
    const featuresKeys = getAllFeaturesKeys(transformed);
    return buildFeatures(transformed, featuresKeys);
  }, [cards]);

  const removeCard = (index) => {
    setCards((prev) => prev.filter((card, i) => i !== index));
  };
  return (
    <div className="content cards-compare-table-wrapper">
      <Sticky topOffset={0} scrollElement=".trigger-sticky">
        <table
          className={clsx(
            'cards-compare-table',
            cards.length >= 3 && 'cards-compare-table-full',
            cards.length < externalCards.length && 'cards-compare-table-shrinked'
          )}
        >
          <CardsCompareTableHeader items={cards} removeItem={removeCard} />
          <tbody></tbody>
        </table>
      </Sticky>
      <table
        className={clsx(
          'cards-compare-table',
          cards.length >= 3 && 'cards-compare-table-full',
          cards.length < externalCards.length && 'cards-compare-table-shrinked'
        )}
      >
        <CardsCompareTableHeader items={cards} removeItem={removeCard} hidden={true} />
        <tbody>
          {Object.keys(features).map((title, index) => (
            <CardsCompareTableFeatureLine key={index} featureList={features[title]} />
          ))}
        </tbody>
        <tfoot>
          <tr>
            <th />
            {cards?.map((card, index) => {
              return (
                <th key={`value${index}`}>
                  <div className="button-wrap flex-it flex-align-item-center flex-wrap flex-col">
                    {card?.fields?.hyperLink && card?.fields?.hyperLink?.value?.href !== '' && (
                      <Button link={card?.fields?.hyperLink} />
                    )}
                    {card?.fields?.infoHyperLink &&
                      card?.fields?.infoHyperLink?.value?.href !== '' && (
                        <Button link={card?.fields?.infoHyperLink} />
                      )}
                  </div>
                </th>
              );
            })}
          </tr>
        </tfoot>
      </table>
    </div>
  );
};

const getAllFeaturesKeys = (transformed) => {
  const existence = new Set();
  const result = [];
  transformed.forEach((features) => {
    features.forEach((feature) => {
      if (!existence.has(feature.nameValue)) {
        existence.add(feature.nameValue);
        result.push({ title: feature.nameTitle, key: feature.nameValue });
      }
    });
  });
  return result;
};

const buildFeatures = (transformed, keys) => {
  //iterating over keys which are [{title, key}, ...]
  return keys.map((featureKey) => {
    //iterating over transformed cards [[feature1, feature2, ...], ...]
    const featureList = transformed.map((features) => {
      //looking for a feature matching featureKey
      const feature = features.find((feature) => feature.nameValue === featureKey.key);
      //if certain card doesn't have this feature - applying N/A
      if (!feature) {
        return {
          nameTitle: featureKey.title,
          nameValue: featureKey.key,
          value: null,
          valueType: cardsCompareFeatureTypes.notExisting,
        };
      }
      return feature;
    });
    return { title: featureKey.title, values: featureList };
  });
};

export default CardsCompareTable;
